import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { QUERY } from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingFooter from "@/view/pages/partials/Listing-Footer";
import { PaginationEventBus } from "@/core/lib/pagination.lib";
export default {
  mixins: [CommonMixin],
  data: function data() {
    return {
      dates: [],
      pageLoading: true,
      activityLog: new Array(),
      filter: {
        search: null
      },
      per_page: 10,
      current_page: 1,
      offset: 0,
      total_pages: 0,
      total_rows: 0
    };
  },
  components: {
    ListingFooter: ListingFooter
  },
  props: {
    type: {
      required: true,
      type: String,
      default: ""
    }
  },
  methods: {
    clearFilter: function clearFilter(field) {
      var _this = this;

      switch (field) {
        case "search":
          _this.filter.search = null;
          break;

        case "dates":
          _this.dates = [];
          break;
      }

      _this.getActivityLog();
    },
    getActivityLog: function getActivityLog() {
      var _this = this;

      _this.pageLoading = true;
      _this.activityLog = [];

      _this.$store.dispatch(QUERY, {
        url: "activity-log/" + _this.type,
        data: {
          per_page: _this.per_page,
          current_page: _this.current_page,
          search: _this.filter.search,
          start_date: _this.dates[0] || null,
          end_date: _this.dates[1] || null
        }
      }).then(function (_ref) {
        var data = _ref.data;
        _this.offset = data.offset;
        _this.activityLog = data.rows;
        _this.total_pages = Math.ceil(data.total_rows / data.per_page);
        _this.current_page = data.current_page;
        _this.total_rows = data.total_rows;
      }).catch(function (error) {
        _this.logError(error);
      }).finally(function () {
        _this.pageLoading = false;
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    /*PaginationEventBus.$off("update:pagination");*/
  },
  mounted: function mounted() {
    var _this = this;

    _this.getActivityLog();

    PaginationEventBus.$on("update:pagination", function (param) {
      _this.current_page = param;

      _this.getActivityLog();
    });
  },
  computed: {
    showingFrom: function showingFrom() {
      return this.lodash.isEmpty(this.activityLog) === false ? this.offset + 1 : 0;
    },
    showingTo: function showingTo() {
      return this.offset + (this.activityLog ? this.activityLog.length : 0);
    }
  }
};